// src/components/common/MobileProfile.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBalance } from '../../BalanceContext';
import { getCurrencySymbol } from '../../utils/TextUtils';
import { BLAUTHTOKEN, CURRENCY_CODE, deleteDataFromStore } from '../../utils/CookiesUtils';
import ModalHalloween from './ModalHalloween';
import toast from 'react-hot-toast';
import { callGetApi } from '../../api/ApiCaller';
import { GET_STATIC_DATA_GET } from '../../api/ApiConst';
import { STATUS } from '../../utils/Constants';


const MobileProfile = ({ onClose }) => {
    const [modalTitle, setModalTitle] = useState('');
    const [showContentModal, setShowContentModal] = useState(false);
    const [webCmsKey, setWebCmsKey] = useState(null)
    const { profileDetails, getPlayerDetails, walletBalance, getWalletBalance, hiddenBalance, setHiddenBalance } = useBalance();

    const navigate = useNavigate();
    const modalRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            // if click outside modal element -> close
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                if (typeof onClose === 'function') onClose();
            }
        }

        // Attach listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const handleNavigation = (path) => {
        navigate(path);
        if (onClose) {
            onClose();
        }
    };

    const handleLogOut = () => {
        deleteDataFromStore(BLAUTHTOKEN);
        deleteDataFromStore(CURRENCY_CODE);
        navigate("/login");
    }
    const handleWebCms = (type) => {
        callGetApi(GET_STATIC_DATA_GET.replaceAll("{websiteCmsKey}", type), {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                const res = response.responsePacket;
                setWebCmsKey(res);
                setShowContentModal(true);
                setModalTitle(type === 'PrivacyPolicy' ? 'Privacy Policy' : 'Terms & Conditions');
            } else {
                toast.error(response.message);
            }
        },
            (e) => {
                toast.error(e.message);
            }
        );
    }
    return (
        <div ref={modalRef} className="mobile-profile" onClick={(e) => e.stopPropagation()}>
            {/* Header Section */}
            <div className="profile-header">
                <div className="d-flex flex-column align-items-start">
                    <div className="username text-left">brgames</div>
                    <div className="balance-amount-text text-left">
                        {hiddenBalance ? '••••' : getCurrencySymbol(profileDetails?.currencyCode) + ' ' + (walletBalance?.toFixed(2) ?? '0.00')}
                    </div>
                    <div className="balance-subtitle text-left">Real balance without bonus</div>
                </div>

                <div className="header-icons">
                    <button className="icon-btn" type="button" onClick={() => setHiddenBalance(!hiddenBalance)}>
                        {/* svg icon (kept same) */}
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ cursor: 'pointer', opacity: 0.8, transition: 'all 0.2s ease', padding: '2px', borderRadius: '4px' }} title={hiddenBalance ? 'Show Balance' : 'Hide Balance'}>
                            {hiddenBalance ? (
                                // Eye-off icon when balance is hidden
                                <>
                                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <line x1="1" y1="1" x2="23" y2="23" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </>
                            ) : (
                                // Eye icon when balance is visible
                                <>
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <circle cx="12" cy="12" r="3" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </>
                            )}
                        </svg>
                    </button>

                    <button
                        type="button"
                        onClick={() => {
                            const btn = document.querySelector('.refresh-icon-btn');
                            if (btn) btn.classList.add('spinning-element');
                            getWalletBalance && getWalletBalance();
                            setTimeout(() => {
                                if (btn) btn.classList.remove('spinning-element');
                            }, 2000);
                        }}
                        className="icon-btn refresh-icon-btn"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="#000">
                            <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* rest of component unchanged */}
            <div className="balance-note my-2">* Balance on the home screen: Sum of all your balances.</div>

            <button onClick={() => handleNavigation('/deposit')} className="deposit-btn gap-2 d-flex align-items-center justify-content-center m-auto w-100">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#000">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
                Deposit
            </button>

            {/* Menu Grid */}
            <div className="menu-grid">
                <button onClick={() => handleNavigation("/personal-data")} className="menu-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                    <span>Profile</span>
                </button>

                <button className="menu-item" onClick={() => handleNavigation("/")}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                    <span>Bets</span>
                </button>

                <button onClick={() => handleNavigation("/withdraw")} className="menu-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
                        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
                    </svg>
                    <span>Withdraw</span>
                </button>

                <button onClick={() => handleNavigation("/account-statement")} className="menu-item">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h8c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
                    </svg>
                    <span>Account statement</span>
                </button>

                <button className="menu-item" onClick={() => handleWebCms('TermsAndConditions')}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
                        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM18.92 8h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
                    </svg>
                    <span>Rules</span>
                </button>

                <button className="menu-item" onClick={() => handleNavigation("/password-security")}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#000">
                        <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
                    </svg>
                    <span>Config</span>
                </button>
            </div>

            <button onClick={handleLogOut} className="logout-btn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="#000">
                    <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                </svg>
                logout
            </button>
            <ModalHalloween show={showContentModal} toggleModel={() => setShowContentModal(false)}>
                <div className="modal-dialog tac-modal modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header dark-card" style={{border: 0, background: '1a1a1a'}}>
                            {/* <span className="btn-close" onClick={() => setShowContentModal(false)} /> */}
                            <i className='fa fa-xmark custom-header-close-btn cursor-pointer' style={{color: '#ff8000'}} onClick={() => setShowContentModal(false)} />
                            <h6 className="m-0 fs-5" style={{color: '#ff8000'}}>{modalTitle}</h6>
                        </div>
                        <div className="modal-body text-black text-start p-2" style={{background: '#2f2f2f'}}>
                            <div className="text-white">
                                <p dangerouslySetInnerHTML={{ __html: webCmsKey }} />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
        </div>
    );
};

export default MobileProfile;